var map = {
	"./news/new-details": [
		"836a",
		"chunk-2d0ddc1c"
	],
	"./partners/partner-details": [
		"20a2",
		"chunk-2d0b1ba5"
	],
	"./users/user-details": [
		"6718",
		"chunk-2d0d019e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "dcca";
module.exports = webpackAsyncContext;